import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import moment from "moment-timezone";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { NeutralColor, PrimaryColor } from "node-library/dist/colors";

interface Props {
	value: string;
	setValue: (timezone: string) => void;
}

function TimeZoneDropdown(props: Props) {
	// Get all available time zones from moment-timezone
	const timezones = moment.tz.names();

	// State to store the current times for all time zones
	const [timeZoneTimes, setTimeZoneTimes] = useState<{ [key: string]: string }>(
		{}
	);

	// Update the current time for all time zones
	useEffect(() => {
		const updateTimes = () => {
			const updatedTimes: { [key: string]: string } = {};
			timezones.forEach((timezone) => {
				updatedTimes[timezone] = moment.tz(timezone).format("HH:mm A");
			});
			setTimeZoneTimes(updatedTimes);
		};

		updateTimes(); // Update times immediately when the component mounts
		const interval = setInterval(updateTimes, 60000); // Update the time every second
		return () => clearInterval(interval); // Clear the interval on component unmount
	}, [timezones]);

	return (
		<div style={{ width: "40%", maxWidth: 400, minWidth: 250 }}>
			<Autocomplete
				disablePortal
				id="timezone-dropdown"
				options={timezones}
				value={props.value}
				popupIcon={<KeyboardArrowDownIcon />} // Toggle icon based on open state
				onChange={(event, newValue) => {
					if (newValue !== null) {
						props.setValue(newValue);
					}
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						label=""
						sx={{
							"& .MuiOutlinedInput-root": {
								padding: "4px 9px", // Custom padding for input field

								"&:hover": {
									borderColor: PrimaryColor.PRIMARY_800, // Change border color on hover
								},
								//   '&.Mui-focused': {
								//     borderColor: 'red', // Change border color when focused
								//   },
							},
							"& .MuiOutlinedInput-root fieldset": {
								borderColor: NeutralColor.NEUTRAL_GREY_900, // Change border color
							},
						}}
					/>
				)}
				getOptionLabel={(option) => {
					// Append the current time to the option label
					const currentTime = timeZoneTimes[option];
					return currentTime
						? `${option.replace("_", " ")} - ${currentTime}`
						: option;
				}}
				isOptionEqualToValue={(option, value) => option === value} // Comparison for selected value
			/>
		</div>
	);
}

export default TimeZoneDropdown;
